module.exports = __webpack_public_path__ + "img/msg.57deeb76.svg";